import React from 'react'
import data from '../data/HomeData.json'
import ProductItem from '../Store/ProductItem'


const S4_home = () => {
  return (
<section className='S4_home'>
<div className='container'>
        <div className='intro' ><h3>Featured Products</h3>  </div>           
<div className='row'>
             {
              data.map((item) => {
                  return (
                      <div className='col-lg-3 col-md-6 ' key={item.id} >
                          <ProductItem {...item } />
                      </div>
                  )
              })
          }
        </div>


</div>


      
</section>
  )
}

export default S4_home